import store from "../store";

const dispatch = (type, payload) => {
  store.dispatch({ type, payload });
};

export default dispatch;
